import {Component, OnInit, Input, Inject, ElementRef, Renderer2, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ProjectActivity} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity';
import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {ActivityType} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/activity-type';
import * as moment from 'moment';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {MvcExceptionResponse} from 'projects/core/src/lib/core/data/mvc-exception-response';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {User} from 'projects/core/src/lib/login/data/user';
import {MatSnackBarRef, SimpleSnackBar} from '@angular/material/snack-bar';
import {HttpEventType} from '@angular/common/http';
import {Subscription, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {OverlayPanel} from 'primeng/overlaypanel';
import {Calendar} from 'primeng/calendar';
import {ProjectService} from '../../data/project/project.service';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {ConfirmationService} from 'primeng/api';
import {MiscSnackBarService} from '../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { PdfPreviewDialogComponent } from '../pdf-preview-dialog/pdf-preview-dialog.component';


@Component({
  selector: 'app-project-activity-dialog',
  templateUrl: './project-activity-dialog.component.html',
  styleUrls: ['./project-activity-dialog.component.scss'],
  providers: [
    ConfirmationService
  ]
})
export class ProjectActivityDialogComponent implements OnInit {
  project: Project;
  projectActivity: ProjectActivity;

  newActivity: boolean;

  @Input()
  activityTypes: ActivityType[] = []
  selectedType: ActivityType;

  dateRange: Date[];
  startDate: Date;
  endDate: Date;
  startTime: Date;

  ignoreTime = false;

  activityDuration: number

  buttonLabel: string;

  deliveryInstructions = '';

  loadingSpinner = false;
  deleteLoadingSpinner = false;

  users: User[] = [];

  selectedUser: User;
  selectedAdditionalUsers: User[] = [];

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  usersIsLoading = false;

  files: File[] = []

  @ViewChild('eventHintOP', {static: true})
  eventHintOP: OverlayPanel

  @ViewChild('dateRangePicker')
  dateRangePicker: Calendar

  opSubs: Subscription;

  activityDots = new Map();

  currentUser: User;

  useWorkloadMode = false;

  durationChangedSubject = new Subject<number>();
  updateSubscription: Subscription;

  temporaryDateRange: Date[];
  activityInitData: any;

  constructor(
    protected dialog: MatDialog,
    protected dialogRef: MatDialogRef<ProjectActivityDialogComponent>,
    protected elementRef: ElementRef,
    protected renderer: Renderer2,
    protected projectService: ProjectService,
    protected confirmationService: ConfirmationService,
    protected projectActivityService: ProjectActivityService,
    protected miscSnackBarService: MiscSnackBarService,
    protected userService: UserService,
    protected appStateQuery: AppStateQuery,
    @Inject(MAT_DIALOG_DATA) public data: { projectActivity: ProjectActivity, project: Project, buttonLabel: string, types: ActivityType[] }
  ) {
    if (data.projectActivity) {
      this.projectActivity = data.projectActivity
    }
    this.project = data.project || this.projectActivity.project

    this.buttonLabel = data.buttonLabel
    this.activityTypes = data.types
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(user => this.currentUser = user)

    this.durationChangedSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(duration => {
      this.calculateEndDate(duration);
    });

    if (this.projectActivity) {
      this.newActivity = false;

      this.selectedType = this.activityTypes.find(type => type.id === this.projectActivity.type.id);

      this.startDate = moment(this.projectActivity.startDate).startOf('day').toDate();
      if (this.projectActivity.endDate) {
        this.endDate = moment(this.projectActivity.endDate).startOf('day').toDate();
        this.dateRange = [this.startDate, this.endDate];
      } else {
        this.dateRange = [this.startDate];
      }
      this.startTime = moment(this.projectActivity.startDate).toDate();
      this.ignoreTime = !this.projectActivity.ignoreTime;

      this.activityDuration = this.projectActivity.duration / 3600;

      this.selectedUser = this.projectActivity.user;

      this.deliveryInstructions = this.projectActivity.deliveryInstructions

    } else {
      this.newActivity = true;
      this.selectedType = this.activityTypes[0]
    }

    this.getInitData();
  }

  getInitData() {
    this.usersIsLoading = true;
    this.projectActivityService.getActivityInitData(this.project.id, this.selectedType.name).subscribe(initData => {
      this.activityInitData = initData;
      this.users = initData.users

      if (this.selectedType.name === 'Installation') {
        this.users.unshift({
          id: null,
          name: 'No User',
          username: 'No User'
        })
      }

      this.usersIsLoading = false;

      if (this.projectActivity && this.projectActivity.user) {
        this.selectedUser = this.users.find(user => user.id === this.projectActivity.user.id)
      } else {
        this.selectedUser = null;
      }

      if (this.projectActivity && this.projectActivity.additionalUsers) {
        this.selectedAdditionalUsers = this.users.filter(user =>
          this.projectActivity.additionalUsers.includes(user.id)
        );
      } else {
        this.selectedAdditionalUsers = [];
      }

      if (!this.projectActivity) {
        this.activityDuration = (this.useWorkloadMode ? initData.durationWA : initData.duration) / 3600
        this.startDate = this.useWorkloadMode ? initData.startDateByWorkload : initData.startDate
        this.dateRange = [this.startDate];
      }

    }, () => {
      this.usersIsLoading = false;
    })
  }

  saveActivityButton() {
    this.loadingSpinner = true;

    let startDate
    let endDate

    if (this.ignoreTime) {
      startDate = moment(this.startDate).startOf('day').add(moment(this.startTime).hours(), 'hours').add(moment(this.startTime).minutes(), 'minutes').toDate()
    } else {
      startDate = this.startDate;
    }

    if (this.endDate) {
      endDate = moment(this.endDate).startOf('day').toDate();
    }

    if (endDate && moment(endDate).isBefore(moment(startDate).startOf('day'))) {
      this.loadingSpinner = false;
      this.miscSnackBarService.openErrorSnackBar('End date cannot be before start date');
      return;
    }

    console.log('saving', this.selectedAdditionalUsers)
    const data = Object.assign(new ProjectActivity(),  {
      id: this.newActivity ? null : this.projectActivity.id,
      startDate,
      endDate,
      duration: this.activityDuration * 3600,
      ignoreTime: !this.ignoreTime,
      user: this.selectedUser,
      additionalUsers: this.selectedAdditionalUsers.map(user => user.id),
      deliveryInstructions: this.deliveryInstructions,
      workloadAware: this.useWorkloadMode
    })
    console.log('saving', data)
    if (this.newActivity) {
      this.projectActivityService.createProjectActivity(this.project.id, this.selectedType.name, data).subscribe(activity => {
          if (this.files.length > 0) {
            this.projectActivityService.uploadFile(this.files, activity.id).subscribe(httpEvent => {
              if (httpEvent.type === HttpEventType.Response) {
                this.dialogRef.close();
              }
            })
          } else {
            this.dialogRef.close();
          }
        },
        error => {
          this.loadingSpinner = false;
          if (error instanceof MvcExceptionResponse) {
            this.miscSnackBarService.openErrorSnackBar(error.message)
          }
        })
    } else {
      this.projectActivityService.saveProjectActivity(data, true)
        .subscribe(activity => {
            this.dialogRef.close(activity);
          },
          error => {
            this.loadingSpinner = false;
            if (error instanceof MvcExceptionResponse && error.type === 'SupressableException') {
              this.openConfirmationDialog(startDate, error.message)
            } else {
              this.miscSnackBarService.openErrorSnackBar(error.message)
            }
          })
    }
  }

  openConfirmationDialog(startDate, message: string) {
    this.confirmationService.confirm({
      header: 'Confirm Move',
      message: `${message}. Would you still like to proceed?`,
      accept: () => {
        let endDate
        if (this.endDate) {
          endDate = moment(this.endDate).startOf('day').toDate();
        }

        const data = Object.assign(new ProjectActivity(),  {
          id: this.newActivity ? null : this.projectActivity.id,
          startDate,
          endDate,
          duration: this.activityDuration * 3600,
          ignoreTime: !this.ignoreTime,
          additionalUsers: this.selectedAdditionalUsers.map(user => user.id),
          deliveryInstructions: this.deliveryInstructions
        })
        if (this.selectedUser) {
          data.user = {id: this.selectedUser.id};
        } else {
          data.user = null;
        }
        this.projectActivityService.saveProjectActivity(data, false)
          .subscribe(activity => {
            this.dialogRef.close(activity);
          }, error => {
            this.miscSnackBarService.openErrorSnackBar(error.message)
          })
      }, reject: () => {
        // this.miscSnackBarService.openErrorSnackBar(message)
      }
    });
  }

  deleteProjectActivity() {
    this.deleteLoadingSpinner = true;
    this.projectActivityService.deleteProjectActivities(this.projectActivity.id).subscribe(() => {
        this.dialogRef.close()
      },
      error => {
        this.loadingSpinner = false;
        this.deleteLoadingSpinner = true;

        if (error instanceof MvcExceptionResponse) {
          this.miscSnackBarService.openErrorSnackBar(error.message)
        }
      })
  }

  onStartDateChange() {
    if (this.endDate && this.activityDuration) {
      this.calculateEndDate(this.activityDuration);
    }
  }

  onDateRangeChange() {
    if (this.dateRange && this.dateRange.length > 0) {
      this.startDate = this.dateRange[0];
      if (this.dateRange.length > 1 && this.dateRange[1]) {
        this.endDate = this.dateRange[1];
        this.calculateDuration();
      } else {
        this.endDate = null;
      }
    }
  }

  onDateRangeClose() {
    this.checkForOverlapping();
    if (this.startDate && this.endDate == null && this.activityDuration) {
      this.projectActivityService.getActivityInitData(this.project.id, this.selectedType.name).subscribe(initData => {
        this.activityDuration = (this.useWorkloadMode ? initData.durationWA : initData.duration) / 3600
      });
    }
  }

  onDurationChange(newDuration: number) {
    this.durationChangedSubject.next(newDuration);
  }

  calculateEndDate(durationHours: number) {
    if (!this.selectedType || !this.startDate || !durationHours) {
        return;
    }
    const durationSeconds = durationHours * 3600;
    const dateFrom = moment(this.startDate).format('YYYY-MM-DD');

    this.projectActivityService.calculateEndDate(this.selectedType.name, dateFrom, durationSeconds).subscribe(endDateStr => {
        if (endDateStr) {
            this.endDate = moment(endDateStr, 'YYYY-MM-DD').toDate();
            this.dateRange = [this.startDate, this.endDate];
        }
    });
  }

  onEndDateChange() {
    if (!this.selectedType || !this.startDate || !this.endDate) {
        return;
    }
    this.calculateDuration();
  }

  calculateDuration() {
     const dateFrom = moment(this.startDate).format('YYYY-MM-DD');
     const dateTo = moment(this.endDate).format('YYYY-MM-DD');

     this.projectActivityService.calculateDuration(this.selectedType.name, dateFrom, dateTo).subscribe(durationSeconds => {
        if (durationSeconds !== null && durationSeconds !== undefined) {
             this.activityDuration = durationSeconds / 3600;
        }
     });
  }

  typeChanged() {
    this.checkForOverlapping();
    this.getInitData();
  }

  checkForOverlapping() {
    const activityData = {
      type: this.selectedType,
      startDate: this.startDate,
      duration: this.activityDuration,
    } as ProjectActivity
    if (this.selectedUser) {
      activityData.user = { id: this.selectedUser.id };
    } else {
      activityData.user = null;
    }

    this.projectActivityService.checkOverlapping(this.project.id, activityData).subscribe(activityOverlap => {
      if (activityOverlap.overlapping) {
        this.miscSnackBarService.openWarningSnackBar(`Overlapping with activity from ${activityOverlap.projectName} project`, 7000)

        // in a future
        // this.startDate = activityOverlap.nearestAvailableTime
      }
    })
  }

  updateFiles(files: File[]) {
    this.files = this.files.concat(files)
  }

  onShown() {
    this.temporaryDateRange = this.dateRange ? [...this.dateRange] : null;

    let startDate: string
    let endDate: string

    if (this.projectActivity) {
      startDate = moment(this.projectActivity.startDate).startOf('month').format('YYYY-MM-DD')
      endDate = moment(this.projectActivity.startDate).endOf('month').format('YYYY-MM-DD')
    } else {
      startDate = moment().startOf('month').format('YYYY-MM-DD')
      endDate = moment().endOf('month').format('YYYY-MM-DD')
    }

    this.getActivityDays(startDate, endDate)
  }

  blurActiveElement() {
    setTimeout(() => {
      const activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement)
        activeElement.blur()
    }, 5);
  }

  monthChanged(event) {
    const startDate = moment().year(event.year).month(event.month - 1).startOf('month').format('YYYY-MM-DD')
    const endDate = moment().year(event.year).month(event.month - 1).endOf('month').format('YYYY-MM-DD')

    this.getActivityDays(startDate, endDate)
  }

  getActivityDays(startDate: string, endDate: string) {
    this.activityDots.clear();

    this.projectActivityService.getActivityDays(this.selectedType.id, startDate, endDate).subscribe(days => {
      days.forEach(day => {
        const actvts = [];

        if (day.projects) {
          day.projects.forEach(proj => {
            actvts.push({
              val: proj.name,
              id: proj.id,
              color: this.selectedType.color
            })
          })
        }

        const holiday = day.holiday as string;
        if (holiday) {
          actvts.push({
            val: holiday,
            color: 'c550de'
          })
        }

        if (actvts.length > 0) {
          this.activityDots.set(moment(day.date).format('D'), actvts)
        }
      })
    })
  }

  updateSelectedUser(userId: number) {
    const fUser = this.users.find(user => user.id === userId)
    if (fUser) {
      this.selectedUser = fUser
      this.projectActivity.user = fUser;
    }
  }

  openReport() {
    const link = `/project/${this.projectActivity.project.id}/packing-slip-report`;
    const dialogHeader = `${this.projectActivity.project.name} Packing Slip Report`


    this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader,
        link,
        showSendButton: false
      },
      panelClass: 'pdf-preview-dialog'
    });
  }

  confirmDateSelection() {
    this.onDateRangeChange();
    this.onDateRangeClose();
    this.dateRangePicker.overlayVisible = false;
  }

  cancelDateSelection() {
    this.dateRange = this.temporaryDateRange ? [...this.temporaryDateRange] : null;
    if (this.dateRange && this.dateRange.length > 0) {
      this.startDate = this.dateRange[0];
      this.endDate = this.dateRange.length > 1 ? this.dateRange[1] : null;
    }
    this.dateRangePicker.overlayVisible = false;
  }

  getSelectedDatesInfo(): string {
    if (!this.dateRange || this.dateRange.length === 0) {
      return '';
    }

    if (this.dateRange.length === 1 || !this.dateRange[1]) {
      return moment(this.dateRange[0]).format('MMM D, YYYY');
    }

    const start = moment(this.dateRange[0]);
    const end = moment(this.dateRange[1]);
    const selectedDays = this.countSelectedDays(start, end);

    let info = `${start.format('MMM D')} - ${end.format('MMM D, YYYY')} (${selectedDays} day${selectedDays !== 1 ? 's' : ''})`;

    if (this.activityInitData && this.activityDuration && this.activityInitData.typeDayDuration) {
      const durationInSeconds = this.activityDuration * 3600;
      const typeDayDurationInSeconds = this.activityInitData.typeDayDuration * 60;
      const requiredDays = Math.ceil(durationInSeconds / typeDayDurationInSeconds);

      if (selectedDays < requiredDays) {
        info += `\nAt least ${requiredDays} day${requiredDays !== 1 ? 's' : ''} needed`;
      }
    }

    return info;
  }

  getDateRangeText(): string {
    if (!this.dateRange || this.dateRange.length === 0) {
      return '';
    }

    if (this.dateRange.length === 1 || !this.dateRange[1]) {
      return moment(this.dateRange[0]).format('MMM D, YYYY');
    }

    const start = moment(this.dateRange[0]);
    const end = moment(this.dateRange[1]);
    const selectedDays = this.countSelectedDays(start, end);

    return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')} (${selectedDays} day${selectedDays !== 1 ? 's' : ''})`;
  }

  getWarningText(): string {
    if (!this.dateRange || this.dateRange.length < 2 || !this.dateRange[1]) {
      return '';
    }

    if (!this.activityInitData || !this.activityDuration || !this.activityInitData.typeDayDuration) {
      return '';
    }

    const start = moment(this.dateRange[0]);
    const end = moment(this.dateRange[1]);
    const selectedDays = this.countSelectedDays(start, end);
    const durationInSeconds = this.activityDuration * 3600;
    const typeDayDurationInSeconds = this.activityInitData.typeDayDuration * 60;
    const requiredDays = Math.ceil(durationInSeconds / typeDayDurationInSeconds);

    if (selectedDays < requiredDays) {
      return `At least ${requiredDays} day${requiredDays !== 1 ? 's' : ''} needed`;
    }

    return '';
  }

  countSelectedDays(start: moment.Moment, end: moment.Moment): number {
    const activityTypesCountAllDays = ['Installation'];

    if (this.selectedType && activityTypesCountAllDays.includes(this.selectedType.name)) {
      return end.diff(start, 'days') + 1;
    }

    let count = 0;
    const current = start.clone();

    while (current.isSameOrBefore(end, 'day')) {
      const dayOfWeek = current.day();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        count++;
      }
      current.add(1, 'day');
    }

    return count;
  }

  hasDateRangeWarning(): boolean {
    if (!this.dateRange || this.dateRange.length < 2 || !this.dateRange[1]) {
      return false;
    }

    if (!this.activityInitData || !this.activityDuration || !this.activityInitData.typeDayDuration) {
      return false;
    }

    const start = moment(this.dateRange[0]);
    const end = moment(this.dateRange[1]);
    const selectedDays = this.countSelectedDays(start, end);
    const durationInSeconds = this.activityDuration * 3600;
    const typeDayDurationInSeconds = this.activityInitData.typeDayDuration * 60;
    const requiredDays = Math.ceil(durationInSeconds / typeDayDurationInSeconds);

    return selectedDays < requiredDays;
  }
}
